import { combineReducers } from 'redux';
import mainReducer from './mainReducer';
import '../components/App.scss';

export default combineReducers({
    mainReducer: mainReducer
});